export default __webpack_public_path__ + "static/media/infoSVGIcon.3d38b6a6.svg";